import { render, staticRenderFns } from "./OrderTrackingHistory.vue?vue&type=template&id=7046722f&scoped=true&"
import script from "./OrderTrackingHistory.vue?vue&type=script&lang=js&"
export * from "./OrderTrackingHistory.vue?vue&type=script&lang=js&"
import style0 from "./OrderTrackingHistory.vue?vue&type=style&index=0&id=7046722f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7046722f",
  null
  
)

export default component.exports